/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentsRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model() {
    let store = this.store;
    return hash({
      group: this.modelFor('group'),
      assessments: store.findAll('assessments/assessment'),
      categories: store.findAll('assessments/category'),
      gradeschedules: store.findAll('assessments/grade-schedule'),
    });
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        // Set activeAssessment on the controller so that it can highlight the correct button.
        let assessmentId = this.paramsFor(
          'group.assessments.assessment',
        ).assessment_id;
        this.controller.set('activeAssessment', assessmentId);
      }
    });
  }
}
